import React, { useEffect } from 'react';
import { DealPipelineView } from '@/components/views/DealPipelineView';

export const ClaimsPage = () => {

	return <DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_CLAIMS}/>;
};